export const buildQueryString = (paramObject?: Record<string, string>) => {
  if (!paramObject) return '';

  // Remove params without search values
  const nextSearchValues = Object.keys(paramObject)
    .filter((key) => !!paramObject[key])
    .reduce((obj, key) => {
      return Object.assign(obj, {
        [key]: paramObject[key],
      });
    }, {});

  // Return empty string if there are no search values
  if (Object.values(nextSearchValues).length === 0) return '';

  const params = new URLSearchParams(nextSearchValues);

  return `?${params}`;
};
